import { ref } from 'vue'
import { apiFetch } from '@/services/api'

export interface TeamMemberStats {
  user_id: string | null
  user_email: string | null
  user_first_name: string | null
  user_last_name: string | null
  prospects_added: number
  active_prospects: number
  outbound_calls: number
  emails_delivered: number
  voicemails_left: number
  li_connects: number
}

export interface TeamActivityResponse {
  members: TeamMemberStats[]
  totals: TeamMemberStats
}

export function useTeamActivity() {
  const data = ref<TeamActivityResponse | null>(null)
  const loading = ref(false)
  const error = ref<string | null>(null)

  async function fetch(params: {
    startDate: string
    endDate: string
    salesPlayId?: string | null
  }) {
    loading.value = true
    error.value = null
    try {
      const query = new URLSearchParams({
        start_date: params.startDate,
        end_date: params.endDate,
      })
      if (params.salesPlayId) {
        query.set('sales_play_id', params.salesPlayId)
      }
      data.value = await apiFetch<TeamActivityResponse>(
        `/reports/team-activity?${query}`,
      )
    } catch (e: any) {
      error.value = e.message || 'Failed to load report'
    } finally {
      loading.value = false
    }
  }

  return { data, loading, error, fetch }
}
